import { apiClient } from './client';

// Tek tanım @raporgor/utils'te (müşteri panelleri de aynı sözlüğü kullanıyor).
// 🔴 `export type { X } from '…'` adı yalnız DIŞARI verir, bu dosyanın KENDİ
// kapsamına SOKMAZ — aşağıdaki `durum: AynaDurumu` alanları TS2304 veriyordu.
// Önce içeri al, sonra yeniden dışarı ver (mevcut tüketiciler kırılmasın).
import type { AynaDurumu } from '@raporgor/utils';
export type { AynaDurumu };

export interface TabloTazeligi {
  tableName: string;
  phase: string;
  lastSeq: number;
  sonSenkronUtc: string;
  yasSaniye: number;
  durum: AynaDurumu;
}

export interface AynaTazeligi {
  firmId: number;
  schemaName: string;
  cdcEnabled: boolean;
  /** Hiç senkron kaydı yoksa null. */
  sonSenkronUtc: string | null;
  /** 🔴 Yaş SUNUCUDA hesaplanır — tarayıcı saati kaymışsa rozet sessizce yanlış çıkardı. */
  yasSaniye: number | null;
  durum: AynaDurumu;
  tablolar: TabloTazeligi[];
}

export const cdcFreshnessApi = {
  get: async (firmId: number): Promise<AynaTazeligi> => {
    const response = await apiClient.get(`/api/admin/cdc/freshness?firmId=${firmId}`);
    return response.data;
  },
};
